const getFormattedApiRequest = data => {
  const extractValues = items =>
    items.reduce((acc, item) => {
      if (item?.value) {
        return [...acc, item?.value];
      }
      return acc;
    }, []);
  return {
    id: data.id,
    ...(data?.priority && { priority: data.priority }),
    effectiveDate: data?.effectiveDate,
    endDate: data?.endDate,
    all: [
      {
        fact: 'client',
        value: extractValues(data?.client || []),
      },
      {
        fact: 'industry',
        value: extractValues(data?.industry || []),
      },
      {
        fact: 'brand',
        value: extractValues(data?.brand || []),
      },
      {
        fact: 'productLine',
        value: extractValues(data?.productLine || []),
      },
      {
        fact: 'serviceSite',
        value: extractValues(data?.serviceSite || []),
      },
      {
        fact: 'serviceType',
        value: extractValues(data?.serviceType || []),
      },
      {
        fact: 'repairSeverity',
        value: extractValues(data?.repairSeverity || []),
      },
      {
        fact: 'repairCode',
        value: data?.repairCode ? data?.repairCode?.split(',') : [],
      },
      {
        fact: 'model',
        value: data?.model ? data?.model?.split(',') : [],
      },
    ],
    event: {
      type: 'LABOR_OUTCOME',
      params: {
        laborRate: parseFloat(data?.laborRate || 0),
        travelRate: parseFloat(data?.travelRate || 0),
      },
    },
  };
};

export default getFormattedApiRequest;
